import type { HierarchyNodeResponse } from '@/features/syllabus/types'

// Subject nodes of the NEET_UG syllabus
export const SYLLABUS_SUBJECTS = [
  { nodeCode: 'NEET_UG_PHY', label: 'Physics' },
  { nodeCode: 'NEET_UG_CHEM', label: 'Chemistry' },
  { nodeCode: 'NEET_UG_BIO', label: 'Biology' },
] as const

/** Below this width By Syllabus shows the tree alone and questions open in the full-screen syllabus browser */
export const SYLLABUS_DESKTOP_QUERY = '(min-width: 1280px)'

export type SyllabusSubjectCode = (typeof SYLLABUS_SUBJECTS)[number]['nodeCode']

export function toSubjectCode(value: string | null): SyllabusSubjectCode {
  return SYLLABUS_SUBJECTS.find((s) => s.nodeCode === value)?.nodeCode ?? SYLLABUS_SUBJECTS[0].nodeCode
}

/** Nodes shown in the PYQ tree: active, real, in-syllabus nodes only */
export function visibleChildren(node: HierarchyNodeResponse): HierarchyNodeResponse[] {
  return (node.children ?? []).filter(
    (child) => child.isActive && child.nodeName !== 'Unknown' && !isOutOfSyllabusNode(child.nodeName)
  )
}

/** Finds a unit or topic (the two browsable levels) under a subject node */
export function findBrowsableNode(
  subject: HierarchyNodeResponse | undefined,
  nodeCode: string | null
): HierarchyNodeResponse | undefined {
  if (!subject || !nodeCode) return undefined
  for (const unit of visibleChildren(subject)) {
    if (unit.nodeCode === nodeCode) return unit
    const topic = visibleChildren(unit).find((t) => t.nodeCode === nodeCode)
    if (topic) return topic
  }
  return undefined
}

export function isOutOfSyllabusNode(nodeName: string): boolean {
  return nodeName.toLowerCase().includes('out of syllabus')
}
